import React from 'react';
import { Card } from 'antd';

const FinancialMetricCard = ({ 
    title, 
    totalValue, 
    fbaValue, 
    fbmValue, 
    suffix = 'USD', 
    color = '#13c2c2', 
    icon: IconComponent,
    description,
    precision = 2 
}) => {
    const formatValue = (value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue.toFixed(precision) : (0).toFixed(precision);
    };
    const hasBreakdown = fbaValue !== undefined && fbmValue !== undefined;
    const displayTotal = formatValue(totalValue);
    const displayFba = formatValue(fbaValue);
    const displayFbm = formatValue(fbmValue);

    return (
        <Card
            size="small"
            style={{
                background: '#fff',
                borderRadius: '12px',
                boxShadow: '2px 4px 9px -5px rgba(0,0,0,0.08)',
                border: '1px solid #f5f5f5',
                height: '72px',
                transition: 'box-shadow 0.2s, border 0.2s',
            }}
            styles={{
                body: {
                    padding: '5px 14px',
                    height: '100%'
                }
            }}
        >
            {/* Title and Icon */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '2px'
            }}>
                <span style={{
                    color: '#8c8c8c',
                    fontSize: '11px',
                    fontWeight: '500'
                }}>
                    {title}
                </span>
                <IconComponent style={{
                    fontSize: '12px',
                    color: color
                }} />
            </div>

            {/* Total Value */}
            <div style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: '3px',
                marginBottom: '3px'
            }}>
                <span style={{
                    color: '#262626',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    lineHeight: '1.2'
                }}>
                    {parseFloat(displayTotal).toLocaleString()}
                </span>
                <span style={{
                    color: '#8c8c8c',
                    fontSize: '8px',
                    fontWeight: '400'
                }}>
                    {suffix}
                </span>
            </div>

            {/* FBA/FBM Breakdown */}
            {hasBreakdown ? (
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: '4px',
                    fontSize: '11px'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px'
                    }}>
                        <div style={{
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            backgroundColor: '#FF9900' // Amazon orange for FBA
                        }} />
                        <span style={{
                            fontWeight: '500'
                        }}>
                            <span style={{ color: '#FF9900' }}>FBA</span>{' '}
                            <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>{parseFloat(displayFba).toLocaleString()}</span>
                        </span>
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '2px'
                    }}>
                        <div style={{
                            width: '4px',
                            height: '4px',
                            borderRadius: '50%',
                            backgroundColor: '#1890ff' // Blue for FBM
                        }} />
                        <span style={{
                            fontWeight: '500'
                        }}>
                            <span style={{ color: '#1890ff' }}>FBM</span>{' '}
                            <span style={{ color: '#8c8c8c', fontWeight: 'bold' }}>{parseFloat(displayFbm).toLocaleString()}</span>
                        </span>
                    </div>
                </div>
            ) : (
                <div style={{
                    fontSize: '9px',
                    color: '#8c8c8c',
                    fontWeight: '400'
                }}>
                    {description}
                </div>
            )}
        </Card>
    );
};

export default FinancialMetricCard;
